import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileDto, StatusService, UserListDto, UsersService } from 'apis/identity';
import { MyUsersService } from '../services/my-users.service';
import { UtilService } from '../services/util.service';
import { ProfileService } from '../../../apis/identity/api/profile.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.page.html',
  styleUrls: ['./user-list.page.scss'],
})
export class UserListPage implements OnInit {

  constructor(public myUsersService: MyUsersService,
              private profileService: ProfileService,
              private router: Router,
              private statusService: StatusService,
              private utilService: UtilService,
              private usersService: UsersService) { }

  ngOnInit() {
    this.utilService.presentLoading('esperando...', () => {
      this.usersService.usersGet(this.myUsersService.usersState).pipe().subscribe( data => {
        console.log(data as Array<UserListDto>);
        this.myUsersService.myUsers = data as Array<UserListDto>;
        this.utilService.loading.dismiss();
      }, error => {
        console.error(error);
        this.utilService.loading.dismiss();
      })
    });
  }

  editUser(index: number) {
    /*
      Aca en lugar de setear, por seguridad, recien ahora, para este en particular, vamos a buscar su info
      para que noquede expuesto todo el listado.
    */
      this.profileService.usersIdProfileGet((this.myUsersService.myUsers[index].id).toString()).pipe().subscribe(data => {
      
      /*
      que objeto uso para guardar, algo propio donde le sumo?, o le agrego al profile?
      */
      this.myUsersService.userToEdit = null;
      this.myUsersService.userToEdit = data as ProfileDto;
      this.myUsersService.userIdToEdit = this.myUsersService.myUsers[index].id;
      //this.myUsersService.userToEdit = this.myUsersService.myUsers[index];
      this.router.navigate(['/user-edit']);

    }, error => {
      console.log(error);
    });

  }

  lockUser(index: number) {
    const status = this.myUsersService.myUsers[index].status === 'ACTIVE'? 'BLOCK': 'ACTIVE';
    this.utilService.presentLoading('esperando...', () => {
      this.statusService.usersIdStatusPost(this.myUsersService.myUsers[index].id.toString(), status).pipe().subscribe(resp => {
        this.myUsersService.myUsers[index].status = status;
        this.utilService.loading.dismiss();
      }, error => {
        console.log(error);
        this.utilService.loading.dismiss();
      })
    });
    
  }

}
